import React from "react";
import Router from "./MyRoutes"
import InviteBanner from "./InviteBanner"

export default function Instructor() {

  return (
    <div >
        <InviteBanner/>
        <Router/>
    </div>
  );
}